export const ICON_SIZE = '36px';
export const FR_ICON_SIZE = '45px';
